<template>
    <div class="h-6 rounded-lg justify-start items-center gap-4 flex">
        <div class="w-6 h-6 relative text-slate-800 dark:text-slate-100 dark:text-slate-200">
            <LoungeIcon :icon="icon" pathClass="fill-slate-800 dark:fill-slate-200" />
        </div>
        <div
            class="text-slate-800 dark:text-slate-100 dark:text-slate-200 text-sm font-normal font-['Inter'] leading-tight"
        >
            {{ label }}
        </div>
    </div>
</template>

<script setup>
import LoungeIcon from '@/components/tools/lounges/partials/lounge-icon/lounge-icon.vue';
const props = defineProps({
    label: String,
    icon: String,
});
</script>
